import { db, sto } from "../../../config/firebaseconfig";

export default function deleteImage(imageId, imagePath) {
  const delStorage = sto.ref().child(imagePath).delete()
  const delDb = db.collection('images').doc(imageId).delete()
  return Promise.all([delStorage, delDb])
}


// WEBPACK FOOTER //
// ./src/helpers/content/manageContent/deleteImage.js